import React from "react";
import {Card, Spin} from "antd";
import JSONInput from "react-json-editor-ajrm";
import moment from "moment";
import {ListItemContainer} from "./CourierWalletPaymentDetail.styles";

export const CourierWalletPaymentDetail = ({payment, loading}) => {
    if (loading) {
        return (
            <Card title={`${date ? moment(date).format("DD MMMM YYYY") : ""} Özeti`}>
                <div style={{textAlign: "center", padding: "20px"}}>
                    <Spin />
                </div>
            </Card>
        );
    }

    return (
        <Card title={`Ödeme Detayı (${payment?.paymentId})`}>
            <ListItemContainer>
                <JSONInput
                    id="paymentJSON"
                    placeholder={payment}
                    theme="dark_mitsuketa_tribute"
                    width="auto"
                    height="auto"
                    viewOnly={true}
                    confirmGood={false}
                />
            </ListItemContainer>
        </Card>
    );
};
